(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _NoQuarterState = require('./states/NoQuarterState');

var _NoQuarterState2 = _interopRequireDefault(_NoQuarterState);

var _HasQuarterState = require('./states/HasQuarterState');

var _HasQuarterState2 = _interopRequireDefault(_HasQuarterState);

var _SoldOutState = require('./states/SoldOutState');

var _SoldOutState2 = _interopRequireDefault(_SoldOutState);

var _SoldState = require('./states/SoldState');

var _SoldState2 = _interopRequireDefault(_SoldState);

var _WinnerState = require('./states/WinnerState');

var _WinnerState2 = _interopRequireDefault(_WinnerState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GumballMachine = function () {
  function GumballMachine() {
    _classCallCheck(this, GumballMachine);

    this.state = new _NoQuarterState2.default(this);
    this.gumballs = 10;
  }

  _createClass(GumballMachine, [{
    key: 'insertQuarter',
    value: function insertQuarter() {
      this.state.insertQuarter();
    }
  }, {
    key: 'ejectQuarter',
    value: function ejectQuarter() {
      this.state.ejectQuarter();
    }
  }, {
    key: 'turnCrank',
    value: function turnCrank() {
      this.state.turnCrank();
    }
  }, {
    key: 'dispense',
    value: function dispense() {
      this.state.dispense();
    }
  }, {
    key: 'getCount',
    value: function getCount() {
      return this.gumballs;
    }
  }, {
    key: 'releaseBall',
    value: function releaseBall() {
      this.state.releaseBall();
    }
  }, {
    key: 'setState',
    value: function setState(state) {
      this.state = state;
    }
  }, {
    key: 'getNoQuarterState',
    value: function getNoQuarterState() {
      return new _NoQuarterState2.default(this);
    }
  }, {
    key: 'getHasQuarterState',
    value: function getHasQuarterState() {
      return new _HasQuarterState2.default(this);
    }
  }, {
    key: 'getSoldOutState',
    value: function getSoldOutState() {
      return new _SoldOutState2.default(this);
    }
  }, {
    key: 'getSoldState',
    value: function getSoldState() {
      return new _SoldState2.default(this);
    }
  }, {
    key: 'getWinnerState',
    value: function getWinnerState() {
      return new _WinnerState2.default(this);
    }
  }]);

  return GumballMachine;
}();

exports.default = GumballMachine;

},{"./states/HasQuarterState":3,"./states/NoQuarterState":4,"./states/SoldOutState":5,"./states/SoldState":6,"./states/WinnerState":8}],2:[function(require,module,exports){
"use strict";

var _GumballMachine = require("./GumballMachine");

var _GumballMachine2 = _interopRequireDefault(_GumballMachine);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var oGumballMachine = new _GumballMachine2.default();

$("#insert_quarter_button").click(function () {
  oGumballMachine.insertQuarter();
});
$("#release_quarter_button").click(function () {
  oGumballMachine.ejectQuarter();
});
$("#turn_crank_button").click(function () {
  oGumballMachine.turnCrank();
  oGumballMachine.dispense();
});

},{"./GumballMachine":1}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _State2 = require('./State');

var _State3 = _interopRequireDefault(_State2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HasQuarterState = function (_State) {
  _inherits(HasQuarterState, _State);

  function HasQuarterState(gumballMachine) {
    _classCallCheck(this, HasQuarterState);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(HasQuarterState).call(this, gumballMachine));

    _this.randomWinner = Math.random();
    return _this;
  }

  _createClass(HasQuarterState, [{
    key: 'insertQuarter',
    value: function insertQuarter() {
      console.log('You can not insert another quarter!');
    }
  }, {
    key: 'ejectQuarter',
    value: function ejectQuarter() {
      console.log('Quarter returned!');
      this.gumballMachine.setState(this.gumballMachine.getNoQuarterState());
    }
  }, {
    key: 'turnCrank',
    value: function turnCrank() {
      console.log("You turned...");
      if (this.randomWinner < 0.20) {
        console.log("Winner state");
        this.gumballMachine.setState(this.gumballMachine.getWinnerState());
      } else {
        console.log("Sold state");
        this.gumballMachine.setState(this.gumballMachine.getSoldState());
      }
    }
  }, {
    key: 'dispense',
    value: function dispense() {
      console.log("No gumball dispensed!");
    }
  }]);

  return HasQuarterState;
}(_State3.default);

exports.default = HasQuarterState;

},{"./State":7}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _State2 = require("./State");

var _State3 = _interopRequireDefault(_State2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NoQuarterState = function (_State) {
  _inherits(NoQuarterState, _State);

  function NoQuarterState() {
    _classCallCheck(this, NoQuarterState);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(NoQuarterState).apply(this, arguments));
  }

  _createClass(NoQuarterState, [{
    key: "insertQuarter",
    value: function insertQuarter() {
      console.log("You inserted a quarter!");
      this.gumballMachine.setState(this.gumballMachine.getHasQuarterState());
    }
  }, {
    key: "ejectQuarter",
    value: function ejectQuarter() {
      console.log("You haven't inserted a quarter!");
    }
  }, {
    key: "turnCrank",
    value: function turnCrank() {
      console.log("You turned, but there is no quarter");
    }
  }, {
    key: "dispense",
    value: function dispense() {
      console.log("You must to pay first!");
    }
  }]);

  return NoQuarterState;
}(_State3.default);

exports.default = NoQuarterState;

},{"./State":7}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _State2 = require("./State");

var _State3 = _interopRequireDefault(_State2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SoldOutState = function (_State) {
  _inherits(SoldOutState, _State);

  function SoldOutState() {
    _classCallCheck(this, SoldOutState);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(SoldOutState).apply(this, arguments));
  }

  _createClass(SoldOutState, [{
    key: "insertQuarter",
    value: function insertQuarter() {
      console.log("You inserted a quarter!");
      this.gumballMachine.setState(this.gumballMachine.getHasQuarterState());
    }
  }, {
    key: "ejectQuarter",
    value: function ejectQuarter() {
      console.log("You haven't inserted a quarter!");
    }
  }, {
    key: "turnCrank",
    value: function turnCrank() {
      console.log("You turned, but there is no quarter");
    }
  }, {
    key: "dispense",
    value: function dispense() {
      console.log("You must to pay first!");
    }
  }]);

  return SoldOutState;
}(_State3.default);

exports.default = SoldOutState;

},{"./State":7}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _State2 = require("./State");

var _State3 = _interopRequireDefault(_State2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SoldState = function (_State) {
  _inherits(SoldState, _State);

  function SoldState() {
    _classCallCheck(this, SoldState);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(SoldState).apply(this, arguments));
  }

  _createClass(SoldState, [{
    key: "insertQuarter",
    value: function insertQuarter() {
      console.log("Please wait, we're already giving you a gumball!");
    }
  }, {
    key: "ejectQuarter",
    value: function ejectQuarter() {
      console.log("Sorry, you already turned the crank!");
    }
  }, {
    key: "turnCrank",
    value: function turnCrank() {
      console.log("Turning twice doesn't get you another gumball!");
    }
  }, {
    key: "releaseBall",
    value: function releaseBall() {
      console.log('Gum is being released.');
      this.gumballMachine.gumballs--;
    }
  }, {
    key: "dispense",
    value: function dispense() {
      if (this.gumballMachine.getCount() > 0) {
        this.gumballMachine.releaseBall();
        this.gumballMachine.setState(this.gumballMachine.getNoQuarterState());
      } else {
        console.log("Oops!, out of gumballs!");
        this.gumballMachine.setState(this.gumballMachine.getSoldOutState());
      }
    }
  }]);

  return SoldState;
}(_State3.default);

exports.default = SoldState;

},{"./State":7}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var State = function () {
  function State(gumballMachine) {
    _classCallCheck(this, State);

    this.gumballMachine = gumballMachine;
  }

  _createClass(State, [{
    key: "insertQuarter",
    value: function insertQuarter() {
      throw new Error("This method must be overwritten!");
    }
  }, {
    key: "releaseBall",
    value: function releaseBall() {
      throw new Error("This method must be overwritten!");
    }
  }, {
    key: "ejectQuarter",
    value: function ejectQuarter() {
      throw new Error("This method must be overwritten!");
    }
  }, {
    key: "turnCrank",
    value: function turnCrank() {
      throw new Error("This method must be overwritten!");
    }
  }, {
    key: "dispense",
    value: function dispense() {
      throw new Error("This method must be overwritten!");
    }
  }]);

  return State;
}();

exports.default = State;

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _State2 = require("./State");

var _State3 = _interopRequireDefault(_State2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WinnerState = function (_State) {
  _inherits(WinnerState, _State);

  function WinnerState() {
    _classCallCheck(this, WinnerState);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(WinnerState).apply(this, arguments));
  }

  _createClass(WinnerState, [{
    key: "insertQuarter",
    value: function insertQuarter() {
      console.log("Please wait, we're already giving you a gumball!");
    }
  }, {
    key: "ejectQuarter",
    value: function ejectQuarter() {
      console.log("Sorry, you already turned the crank!");
    }
  }, {
    key: "turnCrank",
    value: function turnCrank() {
      console.log("Turning twice doesn't get you another gumball!");
    }
  }, {
    key: "releaseBall",
    value: function releaseBall() {
      console.log('Gum is being released.');
      this.gumballMachine.gumballs--;
    }
  }, {
    key: "dispense",
    value: function dispense() {
      console.log("You're a Winner! You get two gumball for your quarter!");
      if (this.gumballMachine.getCount() > 0) {
        this.gumballMachine.releaseBall();
        this.gumballMachine.releaseBall();
        this.gumballMachine.setState(this.gumballMachine.getNoQuarterState());
      } else {
        console.log("Oops!, out of gumballs!");
        this.gumballMachine.setState(this.gumballMachine.getSoldOutState());
      }
    }
  }]);

  return WinnerState;
}(_State3.default);

exports.default = WinnerState;

},{"./State":7}]},{},[2])

